import React from 'react';
import PropTypes from 'prop-types';

const ChargeModalButton = ({ image, children, disabled, ...props }) => (
  <button
    type="button"
    className="c-payment-type-item"
    disabled={disabled}
    {...props}
  >
    <div className="c-payment-type-item__top">
      <img src={image} alt="" />
    </div>
    <div className="c-payment-type-item__bottom">
      <div className="c-payment-type-item__heading u-type--uppercase">Pay by</div>
      <div className="c-heading c-heading--huge u-type--semibold">
        {children}
      </div>
    </div>
  </button>
);
ChargeModalButton.propTypes = {
  disabled: PropTypes.bool,
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
ChargeModalButton.defaultProps = {
  disabled: false,
};

export default ChargeModalButton;
